/** An id of `GET analytics/campaigns`, not the `road-to-rewards` club slug,
 * which the endpoints reject. */
export const ROAD_TO_REWARDS_CAMPAIGN_ID = 'road-to-rewards-2026';
